import { render, staticRenderFns } from "./LayoutWithoutNavbar.vue?vue&type=template&id=b2541c36&"
import script from "./LayoutWithoutNavbar.vue?vue&type=script&lang=js&"
export * from "./LayoutWithoutNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports